/* RESPONSIBLE TEAM: team-inbox-management */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from '../admin-summary';

interface ConversationResumedWireFormat {
  admin_summary: AdminSummaryWireFormat;
}

export default class ConversationResumed implements RenderableData {
  readonly renderableType = RenderableType.ConversationResumed;
  readonly adminSummary: AdminSummary;

  constructor(adminSummary: AdminSummary) {
    this.adminSummary = adminSummary;
  }

  get creatingEntity() {
    return { type: EntityType.Admin, id: this.adminSummary.id };
  }

  static deserialize(json: ConversationResumedWireFormat): ConversationResumed {
    return new ConversationResumed(AdminSummary.deserialize(json.admin_summary));
  }
}
